import { useEffect } from 'react';

function ExecuteFunction({
	func,
	shouldExecute = true,
	conditions = [],
}) {
	useEffect(() => {
		if (shouldExecute) {
			func()
		}
	}, [func, shouldExecute, conditions])
	return ''
}

export default ExecuteFunction;